import React from "react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Download, Copy, FileDown } from "lucide-react";
import { useLang } from "@/contexts/AppContexts";
import { toast } from "sonner";

const sanitizeForExport = (result) => {
  if (!result) return null;
  // Strip large base64 strings to keep JSON small
  const { image_b64, ela_b64, thumb_b64, ...rest } = result;
  return rest;
};

const ExportPanel = ({ result }) => {
  const { t } = useLang();

  const handleDownload = () => {
    if (!result) return;
    const data = JSON.stringify(sanitizeForExport(result), null, 2);
    const blob = new Blob([data], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    const safeName = (result.filename || "report").replace(/[^a-z0-9_.-]/gi, "_");
    a.download = `forensic_${safeName}.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    toast.success(t("export.png_saved"));
  };

  const handleCopy = async () => {
    if (!result) return;
    try {
      await navigator.clipboard.writeText(
        JSON.stringify(sanitizeForExport(result), null, 2)
      );
      toast.success(t("export.json_copied"));
    } catch (err) {
      console.error("Clipboard error:", err);
      toast.error(t("errors.generic") || "Failed to copy");
    }
  };

  return (
    <Card className="p-4 space-y-3" data-testid="export-panel">
      <div className="flex items-center gap-2">
        <FileDown className="h-4 w-4 text-primary" />
        <h3 className="font-display text-sm font-semibold">Export</h3>
      </div>
      <div className="grid grid-cols-1 gap-2">
        <Button
          onClick={handleDownload}
          className="justify-start"
          data-testid="export-json-button"
        >
          <Download className="h-4 w-4 mr-2" />
          {t("export.json")}
        </Button>
        <Button
          variant="outline"
          onClick={handleCopy}
          className="justify-start"
          data-testid="copy-json-button"
        >
          <Copy className="h-4 w-4 mr-2" />
          {t("export.copy_json")}
        </Button>
      </div>
    </Card>
  );
};

export { ExportPanel };
export default ExportPanel;
